/*
 *
 */
import * as React from "react";
import styled from 'styled-components';

/*
 *
 */
const Section = styled.section`
	/*padding-top:3.3vmax;
	padding-bottom:3.3vmax;*/

	padding-top:4vmax;
	padding-bottom:4vmax;
`;

/*
 *
 */
export default ({ children }) => {
	return (
		<Section>
			{children}
		</Section>
	);
}
